var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes },
    [
      _vm.matchingLevelIcon
        ? _c(
            "span",
            { staticClass: "job-vita--grid-area-section-item--matching-icon" },
            [
              _c("Icon", {
                attrs: {
                  icon: _vm.matchingLevelIcon.icon,
                  color: _vm.matchingLevelIcon.color
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _vm.item.title
          ? _c("span", { domProps: { innerHTML: _vm._s(_vm.item.title) } })
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.item.predefinedValue
        ? _c("PredefinedValue", {
            attrs: { "predefined-value": _vm.item.predefinedValue }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.item.extras.length > 0
        ? _c(
            "ul",
            { staticClass: "job-vita--grid-area-section-item-extras" },
            _vm._l(_vm.item.extras, function(extra) {
              return _c("li", { key: extra.id }, [
                extra.label
                  ? _c("span", [_vm._v(_vm._s(extra.label) + ":")])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(extra.value))])
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.item.subItems.length > 0
        ? _c(
            "div",
            { staticClass: "pl-4" },
            _vm._l(_vm.item.subItems, function(subItem) {
              return _c("application-job-vita-grid-area-section-item", {
                key: subItem.id,
                attrs: {
                  item: subItem,
                  "job-profile-id": _vm.jobProfileId,
                  "pseudonym-id": _vm.pseudonymId
                },
                on: {
                  upgrade: function($event) {
                    return _vm.$emit("upgrade")
                  }
                }
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showUpgradePopUp
        ? _c("UpgradePopUp", {
            attrs: {
              "job-profile-id": _vm.jobProfileId,
              "pseudonym-id": _vm.pseudonymId
            },
            on: {
              upgrade: _vm.onUpgrade,
              hidden: function($event) {
                _vm.showUpgradePopUp = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }